"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.preview.title': '预览教程',
    'tutorial.preview.introduction': '介绍',
    'tutorial.preview.learningSteps': '学习步骤',
    'tutorial.preview.tutorialSections': '教程部分',
    'tutorial.preview.knowledgeEntries': '知识条目',
    'tutorial.preview.sectionPrompt': '部分提示',
    'tutorial.preview.knowledgeBase': '知识库',
    'tutorial.preview.stepSections': '步骤部分',
    'tutorial.preview.notFound': '未找到教程',
    'tutorial.preview.notFoundMessage': '无法找到请求的教程或您没有查看权限。',
};
